package eu.bontlab.models

enum class Section(
    val id: String,
    val title: String,
    val subtitle: String,
    val path: String
) {
    Home(
        id = "home",
        title = "Home",
        subtitle = "",
        path = "#home"
    ),
    /*
    About(
        id = "about",
        title = "About me",
        subtitle = "Why Hire Me?",
        path = "#about"
    ),
    Service(
        id = "service",
        title = "Competencies",
        subtitle = "Frameworks, libraries and services",
        path = "#service"
    ),
    */
    PortfolioMapdroid(
        id = "portfolio-Mapdroid",
        title = "\"Trail planner/GPS tracker\"",
        subtitle = "Mapdroid",
        path = "#portfolio-Mapdroid"
    ),
    PortfolioDiarydroid(
        id = "portfolio-Diarydroid",
        title = "Diary/Agenda app",
        subtitle = "Diarydroid",
        path = "#portfolio-Diarydroid"
    ),
    PortfolioSpinplayer(
        id = "portfolio-Spinplayer",
        title = "Create and enjoy your audio/video playlists",
        subtitle = "SpinPlayer",
        path = "#portfolio-Spinplayer"
    ),
    PortfolioFantasyMaze3d(
        id = "portfolio-FantasyMaze3d",
        title = "Labyrinth ball game with fanciful 3D scenarios",
        subtitle = "Fantasy Maze 3D (** on maintenance **)",
        path = "#portfolio-FantasyMaze3d"
    ), /*
    Contact(
        id = "contact",
        title = "Contact me",
        subtitle = "Get in Touch",
        path = "#contact"
    ), */
    Testimonial(
        id = "testimonial",
        title = "Active projects",
        subtitle = "Android APPs",
        path = "#testimonial"
    ) /*,

    Achievements(
        id = "achievements",
        title = "Achievements",
        subtitle = "Personal Achievements",
        path = "#achievements"
    ) */

}